module.exports = __webpack_public_path__ + "static/media/USP3Image.c229b4bc.png";